import { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function WaitlistForm({ product, ctaLabel = "Join Waitlist" }) {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", msg: "" });
    try {
      const { data } = await api.post("/waitlist", {
        product_slug: product.slug,
        product_name: product.name,
        full_name: fullName,
        email,
      });
      setStatus({ state: "done", msg: data.message });
      setFullName(""); setEmail("");
    } catch (err) {
      setStatus({ state: "error", msg: formatApiError(err.response?.data?.detail) });
    }
  };

  if (status.state === "done") {
    return (
      <div data-testid="waitlist-success" className="flex items-center gap-3 border border-primary/40 bg-primary/5 px-5 py-4">
        <Check className="h-5 w-5 text-primary shrink-0" />
        <p className="text-sm text-foreground/90">{status.msg}</p>
      </div>
    );
  }

  const field = "w-full bg-surface border border-border px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none transition-colors";

  return (
    <form onSubmit={submit} data-testid="waitlist-form" className="space-y-3">
      <input data-testid="waitlist-name" required value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Full name" className={field} />
      <input data-testid="waitlist-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" className={field} />
      {status.state === "error" && <p data-testid="waitlist-error" className="text-xs text-destructive">{status.msg}</p>}
      <button data-testid="waitlist-submit" disabled={status.state === "loading"}
        className="group w-full inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground font-medium text-sm px-6 py-3.5 hover:bg-primary-hover transition-colors disabled:opacity-60 shadow-[0_0_20px_rgba(0,229,153,0.3)]">
        {status.state === "loading" ? "Sending…" : ctaLabel}
        <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
      </button>
    </form>
  );
}
